import { useContext } from 'react'
import { AdVehicleDoorStatusContext } from './AdDoorStatusProvider'

export const useAdVehicleDoorStatus = () => {
  const AdVehicleDoorStatusValue = useContext(AdVehicleDoorStatusContext)

  if (!AdVehicleDoorStatusValue) {
    throw new Error(
      'useAdVehicleDoorStatus must be used within a AdVehicleDoorStatusProvider',
    )
  }

  return AdVehicleDoorStatusValue
}
